export default "__VITE_PUBLIC_ASSET__8a4a3040__"